/* eslint-disable import/no-unresolved */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */

import { useEffect, useState } from 'react';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { resetTradeScreenLayout } from 'actions/layoutSetup';
import {
  // updatePortfolioMarginMode,
  updateTradePreference,
} from 'actions/trade';
import { isAuthenticated, updateUserPreference } from 'actions/user';
import { disableScrolling, enableScrolling } from 'components/Header/partials/get_change';
import Modal from 'components/modal';
import { WalletConvertIcon } from 'components/primaryHeader/partials/walletMenu/walletIcons';
import ToggleThemeSwitch from 'components/toggleThemeSwitch';
import { IS_INDIAN_EXCHANGE, MARGIN_TYPES } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES, MIXPANEL_SOURCES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { noop } from 'helpers/utils';
// import { getOrderLeverage } from 'actions/orderbook';
// import { AssetSelection } from 'components/leverage/marginTypes/helpers';
// import { PortfolioWrapper } from 'components/leverage/marginTypes/styles';
// import { PORTFOLIO_MARGIN_GUIDE_LINK, MARGIN_TYPES } from 'constants/constants';
// import useLocalStorage from 'hooks/useLocalStorage';
import { tradeScreenLayoutStatusSelector } from 'selectors/layoutSetupSelector';
import {
  allPrefrencesSelector,
  userMarginModeSelector,
  userSelector,
} from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import { LearnMoreIcon, SettingsIcon } from 'styles/assets/icons';
import AntToggle from 'UIKit/AntToggle';
import Box from 'UIKit/Box';
import ToggleButtonSwitch from 'UIKit/ToggleSwitchButton';

import styles from './index.module.scss';

const PreferencesSettingsMenu = () => {
  const { t } = useTranslation(['headerFooter', 'account']);
  const history = useHistory();
  const dispatch = useDispatch();
  const [isPreferencesMenuOpen, setPreferencesMenuOpen] = useState(false);

  const handleClose = () => {
    setPreferencesMenuOpen(false);
  };

  const allPreferences = useSelector(state => allPrefrencesSelector(state));
  const user = useSelector(state => userSelector(state));
  const isLoggedin = isAuthenticated(user);
  const tradeScreenLayoutStatus = useSelector(tradeScreenLayoutStatusSelector);
  const marginMode = useAppSelector(userMarginModeSelector);
  const [isWatchlistActive, setWatchlistActive] = useState(
    user.preferences.showOnlyFavsOnTicker
  );

  const [showModal, setShowModal] = useState(false);
  const showAutoTopUp = marginMode === MARGIN_TYPES.ISOLATED;

  const {
    deto_for_commission,
    limitOrder,
    marketOrder,
    stopLimitOrder,
    stopMarketOrder,
    trailingStopOrder,
    takeProfitLimitOrder,
    takeProfitMarketOrder,
    fatFingerProtection,
    alwaysShowOnMobile,
    email_preferences,
    vip_level,
  } = allPreferences || {};

  const prefrencesMenu = [
    // {
    //   label: t('headerFooter:header.settings.interestCredit'),
    //   key: 'interest_credit',
    //   hasLearnMore: true,
    //   isTradeprefrence: true,
    //   hasFinerControl: false,
    // },

    {
      label: t('headerFooter:header.settings.defaultAutoTopUp'),
      key: 'default_auto_topup',
      hasLearnMore: false,
      isTradeprefrence: true,
      hasFinerControl: false,
      isLabelShown: showAutoTopUp,
    },

    {
      label: t('headerFooter:header.settings.positionForSocialShare'),
      key: 'positionForSocialShare',
      hasLearnMore: false,
      isTradeprefrence: false,
      hasFinerControl: false,
      isLabelShown: true,
    },
    // {
    //   label: t('headerFooter:header.settings.showTicker'),
    //   key: 'showTicker',
    //   hasLearnMore: false,
    //   isTradeprefrence: false,
    //   hasFinerControl: false,
    //   isLabelShown: true,
    // },
    // {
    //   label:  t('headerFooter:header.settings.showAllTickers'),
    //   key: 'tickerText',
    //   hasLearnMore:false,
    //   isTradeprefrence:false,
    //   hasFinerControl : false,
    //   isLabelShown : true
    // },
    // {
    //   label: !isWatchlistActive
    //     ? t('headerFooter:header.settings.showAllTickers')
    //     : t('headerFooter:header.settings.showWatchlist'),
    //   key: 'toggleButton',
    //   hasLearnMore: false,
    //   isTradeprefrence: false,
    //   hasFinerControl: false,
    //   isLabelShown: user.preferences.showTicker,
    // },
    {
      label: t('headerFooter:header.settings.confirmationMessages'),
      key: 'confirmation_messages',
      hasLearnMore: false,
      isTradeprefrence: false,
      hasFinerControl: true,
      isLabelShown: true,
    },
    {
      label: t('headerFooter:header.settings.emailAlerts'),
      key: 'email_alerts',
      hasLearnMore: false,
      isTradeprefrence: true,
      hasFinerControl: true,
      isLabelShown: true,
    },
  ];

  const getSwitchBoolValue = key => {
    if (key === 'confirmation_messages') {
      return (
        limitOrder &&
        marketOrder &&
        stopLimitOrder &&
        stopMarketOrder &&
        trailingStopOrder &&
        takeProfitLimitOrder &&
        takeProfitMarketOrder &&
        fatFingerProtection &&
        alwaysShowOnMobile
      );
    }
    if (key === 'email_alerts') {
      const isEmailAlertOn = !Object.values(email_preferences).some(value => !value);
      return isEmailAlertOn;
    }
    return allPreferences[key];
  };

  const showTickerData = key => {
    if (key === 'All') {
      setWatchlistActive(false);
      dispatch(updateUserPreference({ preferences: { showOnlyFavsOnTicker: false } }));
    } else {
      setWatchlistActive(true);
      dispatch(updateUserPreference({ preferences: { showOnlyFavsOnTicker: true } }));
    }
  };

  const onToggle = (event, prefrences) => {
    const {
      target: { checked, name },
    } = event;
    if (prefrences.key === 'confirmation_messages') {
      return dispatch(
        updateUserPreference({
          preferences: {
            limitOrder: checked,
            marketOrder: checked,
            stopLimitOrder: checked,
            stopMarketOrder: checked,
            trailingStopOrder: checked,
            fatFingerProtection: checked,
            alwaysShowOnMobile: checked,
            takeProfitLimitOrder: checked,
            takeProfitMarketOrder: checked,
            [name]: checked,
          },
        })
      );
    }

    if (prefrences.isTradeprefrence) {
      if (prefrences.key === 'email_alerts') {
        const emailPrefPayload = Object.keys(email_preferences).reduce(
          (acc, key) => ({ ...acc, [key]: checked }),
          {}
        );
        dispatch(updateTradePreference({ email_preferences: emailPrefPayload }));
      } else {
        dispatch(updateTradePreference({ [name]: checked }));
      }
    } else {
      dispatch(updateUserPreference({ preferences: { [name]: checked } }));
    }
    return null;
  };

  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      position: 'inherit',
      transform: '',
      width: 'fit-content',
    },
  };

  const onDetoCommissionToggle = ({ target: { checked } }) => {
    if (user.is_kyc_done) {
      dispatch(
        updateTradePreference({
          deto_for_commission: checked,
        })
      );
    } else {
      setShowModal(true);
      setPreferencesMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isPreferencesMenuOpen) {
      disableScrolling();
    } else {
      enableScrolling();
    }
  }, [isPreferencesMenuOpen]);

  // const getLeverage = () =>
  //   selectedProduct && dispatch(getOrderLeverage(selectedProduct));

  const resetTradeLayout = e => {
    e.preventDefault();
    if (tradeScreenLayoutStatus) {
      dispatch(resetTradeScreenLayout());
      setPreferencesMenuOpen(false);
    }
  };

  const getVerifiedClick = () => {
    history.push(routes.account.identityVerification);
    setShowModal(false);
  };

  const handleOnGoHereClick = key => {
    if (key) {
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.PREFERENCES_CLICKED, {
        source: MIXPANEL_SOURCES.SETTINGS_GO_HERE,
        key,
      });
    }
  };

  const manageAllPreferencesClick = () => {
    history.push(routes.account.preferences);
    setPreferencesMenuOpen(false);
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.PREFERENCES_CLICKED, {
      source: MIXPANEL_SOURCES.SETTINGS_MANAGE_ALL_PREFERENCES,
    });
  };

  return (<>
    <ClickAwayListener onClickAway={handleClose}>
      <div className={styles.preferencesSettingsMenu}>
        <Menu
          menuButton={({ open }) => (
            <MenuButton
              data-testid="settings-panel"
              className={`${open ? styles.active : ''} ${styles.button}`}
              onClick={() => {
                trackMixpanelEvent('Preferences Clicked - All Pages');
                setPreferencesMenuOpen(!isPreferencesMenuOpen);
              }}
            >
              <SettingsIcon width="18" height="18" />{' '}
            </MenuButton>
          )}
          menuClassName={styles.preferenceMenu}
          gap={14}
        >
          <MenuItem
            data-testid="8h7Fxvi4V2Yvwm3XkiI-z"
            className={styles['preference-menu-item']}
            onClick={e => {
              const event = e;
              event.keepOpen = true;
            }}
          >
            <span className={styles.label}>
              {t('headerFooter:header.settings.theme')}
            </span>
            <ToggleThemeSwitch />
          </MenuItem>

          <MenuItem
            data-testid="-OWONZ_bgSYz-eTnhF7R-"
            className={styles['preference-menu-item']}
            onClick={e => {
              const event = e;
              event.keepOpen = true;
            }}
          >
            <span className={styles.label}>
              {t('trading:header.changeLayout.tradingTerminalLayout')}
            </span>

            <span className={styles['toggle-switch']}>
              <div
                data-testid="resetTradeLayout"
                className={`${tradeScreenLayoutStatus ? styles.active : ''} ${
                  styles['convert-button']
                }`}
                role="button"
                tabIndex={0}
                onKeyDown={noop}
                onClick={resetTradeLayout}
                disabled={!tradeScreenLayoutStatus}
              >
                <WalletConvertIcon className={styles['convert-icon']} />

                {t('trading:header.changeLayout.restoreDefault')}
              </div>
            </span>
          </MenuItem>

          {isLoggedin && vip_level === 0 && !IS_INDIAN_EXCHANGE && (
            <MenuItem
              data-testid="HZhM2kwnMk7bg1zqw7Hg6"
              className={styles['preference-menu-item']}
              onClick={e => {
                const event = e;
                event.keepOpen = true;
              }}
            >
              <span className={styles.label}>
                {t('headerFooter:header.settings.payInDeto')}
                <a
                  data-testid="trading-fee-link"
                  className={styles['learn-more']}
                  href="https://www.delta.exchange/blog/support/paying-trading-fees-in-deto/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('headerFooter:header.settings.learnMore')}
                  <LearnMoreIcon />
                </a>
              </span>

              <span className={styles['toggle-switch']}>
                <AntToggle
                  data-testid="detoCommission"
                  checked={deto_for_commission}
                  onChange={event => {
                    onDetoCommissionToggle(event);
                  }}
                  name="deto_for_commission"
                />
              </span>
            </MenuItem>
          )}
          {isLoggedin &&
            prefrencesMenu.map(
              prefrences =>
                prefrences.isLabelShown && (
                  <MenuItem
                    data-testid="sxizWI-SttV0cNNCfKATp"
                    key={prefrences.key}
                    className={`${styles['preference-menu-item']} ${
                      prefrences.key === 'toggleButton' &&
                      styles['ticker-item-container']
                    }`}
                    onClick={e => {
                      const event = e;
                      event.keepOpen = true;
                    }}
                  >
                    <span
                      className={`${styles.label} ${
                        prefrences.key === 'toggleButton' &&
                        styles['ticker-options-label']
                      }`}
                    >
                      {prefrences.label}
                      {prefrences.hasLearnMore && (
                        <a
                          data-testid="interestBearingAccountLink"
                          className={styles['learn-more']}
                          href="https://www.delta.exchange/interest-bearing-account/"
                          target="_blank"
                          rel="noreferrer"
                          data-palette="PreferencesSettingsMenu">
                          {t('headerFooter:header.settings.learnMore')}{' '}
                          <LearnMoreIcon />
                        </a>
                      )}
                      {prefrences.hasFinerControl && (
                        <span
                          className={styles['finer-control-text']}
                          data-palette="PreferencesSettingsMenu">
                          {' '}
                          <Link
                            to={{
                              pathname: routes.account.preferences,
                              state: { from: history.location },
                            }}
                            data-testid="go-here-button"
                            onClick={() => handleOnGoHereClick(prefrences.key)}
                          >
                            {t('headerFooter:header.settings.goHere')}
                          </Link>{' '}
                          {t('headerFooter:header.settings.forFinerControl')}
                        </span>
                      )}
                    </span>
                    {prefrences.key === 'toggleButton' ? (
                      <ToggleButtonSwitch
                        data-testid="showWatchListBtn"
                        leftButtonName={t('headerFooter:header.settings.showAllButton')}
                        rightButtonName={t(
                          'headerFooter:header.settings.showWatchlistButton'
                        )}
                        leftClickHandler={() => showTickerData('All')}
                        rightClickHandler={() => showTickerData('Watchlist')}
                        activeButtonName={
                          isWatchlistActive
                            ? t('headerFooter:header.settings.showWatchlistButton')
                            : t('headerFooter:header.settings.showAllButton')
                        }
                      />
                    ) : (
                      <span
                        className={styles['toggle-switch']}
                        data-palette="PreferencesSettingsMenu">
                        <AntToggle
                          data-testid={`antSwitch ${prefrences.key}`}
                          checked={getSwitchBoolValue(prefrences.key)}
                          onChange={event => onToggle(event, prefrences)}
                          name={prefrences.key}
                        />
                      </span>
                    )}
                  </MenuItem>
                )
            )}
          {isLoggedin && (
            <MenuItem
              data-testid="Q9VZO3mTSwbTDpi06iw62"
              className={styles['manage-prefrences-button']}
              onClick={manageAllPreferencesClick}
            >
              {t('headerFooter:header.settings.manageAllPreferences')}
            </MenuItem>
          )}
        </Menu>
        <Modal isOpen={showModal} onRequestClose={() => null} style={modalStyles}>
          <Box className={`${styles.modalWrapper} ${styles[`deto-commission`]}`}>
            <div className={styles.body}>
              {t('headerFooter:header.settings.featureForVerified')}
            </div>
            <div className={`${styles.buttons}`}>
              <button
                data-testid="A9YM5UJdG3IrbBQzQbUJV"
                type="button"
                className={styles.confirm_button}
                onClick={getVerifiedClick}
              >
                {t('headerFooter:header.settings.getVerified')}
              </button>
              <button
                data-testid="cTzlnuEwAKUTQ9pnvb88l"
                type="button"
                className={styles.cancel_button}
                onClick={() => setShowModal(false)}
              >
                {t('headerFooter:header.settings.cancel')}
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </ClickAwayListener>
    {isPreferencesMenuOpen && <div className={styles.overlay} data-palette="PreferencesSettingsMenu" />}
  </>);
};

export default PreferencesSettingsMenu;
